import { Formik, Form } from 'formik';
import {
    initialValues,
    validationSchema_18732,
} from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Phone from 'blocks/Form/fields/Phone';
import Submit from 'blocks/Form/fields/Submit';
import Address from 'blocks/Form/fields/Address';
import Location from 'blocks/Form/fields/Location';
import HeartValve from 'blocks/Form/fields/HeartValve';
import DateOfBirth from 'blocks/Form/fields/DateOfBirth';
import Ethnicity from 'blocks/Form/fields/Ethnicity';
import GenderSex from 'blocks/Form/fields/GenderSex';
import LeadSourceDetails from 'blocks/Form/fields/LeadSourceDetail';
import DiagnosedConditions from 'blocks/Form/fields/DiagnosedConditions';
import TreatmentStory from 'blocks/Form/fields/TreatmentStory';
import BringGuest from 'blocks/Form/fields/BringGuest';
import ConsentRelease from 'blocks/Form/fields/ConsentRelease';
import IallowEdwards from 'blocks/Form/fields/IallowEdwards';
import Profession from 'blocks/Form/fields/Profession';
import MultiPurposeOptIn from 'blocks/Form/fields/MultiPurposeOptIn';

/* === CORP - Patient Experience === */

const Form18732 = ({ handleSubmit, isPending, language, fields }) => {
    const {
        first_name,
        last_name,
        email_address,
        phone,
        address,
        location,
        profession,
        race_ethnicity,
        date_of_birth,
        gender_sex,
        heart_valve_or_ring,
        how_did_you_learn,
        diagnosed_conditions,
        treatment_story,
        patient_experience_attendees,
        consent_release,
        i_allow_edwards,
        submit,
        validation,
    } = fields;
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit('marketo', values)}
            validationSchema={validationSchema_18732(validation)}
        >
            {(formik) => (
                <Form className="form form--lg">
                    <div className="grid-lg-2 row-gap-0">
                        <FirstName
                            label={first_name}
                            initialValues={initialValues}
                        />
                        <LastName
                            label={last_name}
                            initialValues={initialValues}
                        />
                        <Email
                            label={email_address}
                            initialValues={initialValues}
                        />
                        <Phone label={phone} initialValues={initialValues} />
                    </div>
                    <Address label={address} initialValues={initialValues} />
                    <div className="grid-lg-2 row-gap-0">
                        <Location
                            data={location}
                            formik={formik}
                            initialValues={initialValues}
                        />
                        <Profession
                            label={profession}
                            initialValues={initialValues}
                        />
                    </div>
                    <div className="grid-lg-2 row-gap-0">
                        <Ethnicity
                            data={race_ethnicity}
                            initialValues={initialValues}
                        />
                        <DateOfBirth
                            label={date_of_birth}
                            initialValues={initialValues}
                        />
                        <GenderSex
                            data={gender_sex}
                            initialValues={initialValues}
                        />
                    </div>
                    <HeartValve
                        data={heart_valve_or_ring}
                        initialValues={initialValues}
                        formik={formik}
                    />
                    <LeadSourceDetails
                        data={how_did_you_learn}
                        initialValues={initialValues}
                        formik={formik}
                    />
                    <DiagnosedConditions
                        data={diagnosed_conditions}
                        initialValues={initialValues}
                    />
                    <TreatmentStory
                        label={treatment_story}
                        initialValues={initialValues}
                    />
                    <BringGuest
                        data={patient_experience_attendees}
                        initialValues={initialValues}
                        formik={formik}
                    />
                    <ConsentRelease
                        data={consent_release}
                        initialValues={initialValues}
                    />
                    <IallowEdwards
                        data={i_allow_edwards}
                        initialValues={initialValues}
                    />
                    <MultiPurposeOptIn
                        initialValues={initialValues}
                        language={language}
                        formik={formik}
                    />
                    <Submit
                        formik={formik}
                        isPending={isPending}
                        pendingText={submit.submitting}
                        validation={submit.all_required_fields}
                    >
                        {submit.send_us_your_message}
                    </Submit>
                </Form>
            )}
        </Formik>
    );
};

export default Form18732;
